import { ReactNode, useEffect, useRef } from 'react'

import { AdSlot, Wrapper } from './ad-area.styles'

export interface AdAreaProps {
  insId: string
  height: number
  width: number
  leftMargin?: number
  rightMargin?: number
  leftPadding?: number
  rightPadding?: number

  children: ReactNode
}
export const AdArea = (props: AdAreaProps) => {
  const {
    insId,
    height = 600,
    width = 300,
    leftMargin = 0,
    rightMargin = 0,
    leftPadding = 0,
    rightPadding = 0,
    children,
  } = props

  const adPushed = useRef(false)
  const insIdRef = useRef(insId)

  useEffect(() => {
    let repeatId: NodeJS.Timer

    // re-try to push ad every 50ms until it's pushed, because sometimes the <ins> tag doesn't load before this effect runs
    const tryToPushAd = () => {
      repeatId = setInterval(() => {
        if (adPushed.current) return

        const insFound = document.getElementById(insIdRef.current)

        // check if <ins> tag is found
        if (!insFound) return

        try {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // <Script> tag that we attach with each <ins> call doesn't rerender on page route change, so do it in this useEffect
          ;(adsbygoogle = window.adsbygoogle || []).push({})

          clearInterval(repeatId)

          adPushed.current = true
        } catch (e) {
          // do nothing
        }
      }, 50)
    }

    // sometimes in slow network, the <ins> tag doesn't load before this effect runs, therefore add a setTimeout to skip one render
    const timeoutId = setTimeout(tryToPushAd)

    return () => {
      adPushed.current = false
      clearInterval(repeatId)
      clearTimeout(timeoutId)
    }
  }, [])

  return (
    <>
      <Wrapper
        width={width}
        leftMargin={leftMargin}
        rightMargin={rightMargin}
        leftPadding={leftPadding}
        rightPadding={rightPadding}
      >
        <AdSlot height={height}>{children}</AdSlot>
      </Wrapper>
    </>
  )
}
